import FinalRecap from './final-recap';

export default FinalRecap;